import { defaultWidth, defaultHeight } from "../defaults.js";

const drawCaseRefinement = (container, data, onDrag) => {
  // draw a curved path from the top to the bottom of the case refinement
  const bindingData = [data];

  const path = container.selectAll("path.rpath").data(bindingData);
  path
    .enter()
    .append("path")
    .classed("rpath", true)
    .merge(path)
    .attr("d", () => {
      // Starting point
      const startX = defaultWidth / 2;
      const startY = -defaultHeight / 2;

      // Vertical line down to start curve
      const verticalEndY = 0;

      // Control points for cubic bezier curve to create the curve to the right
      // Adjust these points to control the shape of the curve
      const cp1X = startX; // First control point - same x as starting point to go down vertically
      const cp1Y = verticalEndY + 2; // Move the first control point down a bit to start the curve
      const cp2X = startX + 5; // Second control point - move to the right to create the horizontal end
      const cp2Y = verticalEndY + 5; // Adjust the y to control the curve's height
      const endX = startX + 34; // End point x - to the right of the start
      const endY = verticalEndY + 5; // End point y - same y as vertical end to finish horizontally

      // Construct the path string
      return `M${startX},${startY} V${verticalEndY} C${cp1X},${cp1Y} ${cp2X},${cp2Y} ${endX},${endY}`;
    })
    .on("click", (event, d) => {
      console.log("Path clicked:", d);
    });
  path.exit().remove();
  drawReturnState(container, data);

  const caseLabel = container.selectAll("text.label").data((d) => [d]);
  caseLabel
    .enter()
    .append("text")
    .classed("label", true)
    .merge(caseLabel)
    .attr("x", 0)
    .attr("y", 0)
    .attr("dy", "0.35em")
    .attr("text-anchor", "end")
    .text((d) => d.label || "case")
    .on("click", (event, d) => {
      console.log("Label clicked:", d);
    })
    .call(onDrag);
};

const drawReturnState = (container, data) => {
  const bindingData = [data];
  const path = container.selectAll("path.retpath").data(bindingData);
  path
    .enter()
    .append("path")
    .classed("retpath", true)
    .merge(path)
    .attr("data-class", "ref-return")
    .attr("d", (d) => {
      // Starting point is the furthest subthread to the right that returns to the part sequence
      const startX = d.furthestX + defaultWidth / 2;
      // Control points for cubic bezier curve to create the curve to the left
      const startY = d.size.height;
      const lineIn = d.furthestX - d.position.x - defaultWidth * 2;
      const endX = d.position.x + defaultWidth * 2; // End point x - to the left of the start

      // Construct the path string
      return `M${startX},${startY}  
              l${-lineIn} ${0} 
              c${0}, ${0} 
               ${-endX}, ${5} 
               ${-endX}, ${20}`;
    });
  path.exit().remove();
};

export { drawCaseRefinement };
